import styled from "@emotion/styled";
import { DetectByEvent as PropTypes } from "../../types/types";
import {
  AccidentMarker,
  DangerousDrivingMarker,
  IdleTimeMarker,
  NomalMarker,
  TotalEventsMarker,
  WarningBatteryMarker,
  WarningEscapeMarker,
} from "../../assets/icons/icons";
import { useWindowSize } from "@reactuses/core";
import theme from "../../theme";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const DetectByEvent: React.FC<{
  eventData: PropTypes[] | undefined;
  onClickEvent: (eventCode: number) => void;
}> = (props) => {
  const { t } = useI18n();
  const { eventData, onClickEvent } = props;
  const { width } = useWindowSize();
  // const [isFold, setIsFold] = useState(true);

  const getTotalDetect = () => {
    let total = 0;
    eventData?.forEach((el) => {
      if (el.event !== "전체농기계" && el.event !== "운행한농기계") total += el.cnt;
    });
    return total;
  };

  // const handleClickWrapper = () => {
  //   if (width > md) return;
  //   setIsFold((prev) => !prev);
  // };

  return (
    <Wrapper
      // $isFold={isFold}
      $isFold={false}
      // onClick={handleClickWrapper}
    >
      <Header>
        {width > md ? t.statistics.detectByType : t.statistics.detectList}
      </Header>
      <Body>
        <EventWrapper onClick={() => onClickEvent(-1)}>
          <EventHeader>{t.statistics.operatedMachinery} / {t.statistics.totalMachinery}</EventHeader>
          <MarkerAndCountWrapper>
            <NomalMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "운행한농기계")?.cnt} / {eventData?.find((el) => el.event === "전체농기계")?.cnt} {t.statistics.units}
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        <Separator />
        <EventWrapper onClick={() => onClickEvent(0)}>
          <EventHeader>{t.statistics.totalDetections}</EventHeader>
          <MarkerAndCountWrapper>
            <TotalEventsMarker width="30px" height="30px" />
            <EventCnt>{getTotalDetect()}{t.statistics.cases}</EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        <Separator />
        <EventWrapper onClick={() => onClickEvent(2)}>
          <EventHeader>{t.statistics.rolloverDetections}</EventHeader>
          <MarkerAndCountWrapper>
            <AccidentMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "차량전복")?.cnt || 0}
              {t.statistics.cases}
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        <Separator />
        <EventWrapper onClick={() => onClickEvent(3)}>
          <EventHeader>{t.statistics.dangerousDrivingDetections}</EventHeader>
          <MarkerAndCountWrapper>
            <DangerousDrivingMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "위험운전")?.cnt || 0}
              {t.statistics.cases}
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        {/* <Separator />
        <EventWrapper>
          <EventHeader>위험구역 진입 감지내역 (전체)</EventHeader>
          <MarkerAndCountWrapper>
            <DangerousAreaMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "위험지역진입")?.cnt ||
                0}
              건
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper> */}
        <Separator />
        <EventWrapper onClick={() => onClickEvent(6)}>
          <EventHeader>{t.statistics.outOfAreaDetections}</EventHeader>
          <MarkerAndCountWrapper>
            <WarningEscapeMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "사용지역이탈")?.cnt ||
                0}
              {t.statistics.cases}
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        <Separator />
        <EventWrapper onClick={() => onClickEvent(8)}>
          <EventHeader>{t.statistics.batteryAnomalyDetections}</EventHeader>
          <MarkerAndCountWrapper>
            <WarningBatteryMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "배터리부족")?.cnt ||
                0}
              {t.statistics.cases}
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        <Separator />
        <EventWrapper onClick={() => onClickEvent(5)}>
          <EventHeader>{t.statistics.ignitionNeglectDetections}</EventHeader>
          <MarkerAndCountWrapper>
            <IdleTimeMarker width="30px" height="30px" />
            <EventCnt>
              {eventData?.find((el) => el.event === "시동방치")?.cnt || 0}
              {t.statistics.cases}
            </EventCnt>
          </MarkerAndCountWrapper>
        </EventWrapper>
        <Separator />
      </Body>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $isFold: boolean }>`
  width: 252px;
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  /* height: 100%; */
  height: 943px;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: 200ms;

  @media (max-width: ${md}px) {
    width: 100%;
    max-height: ${({ $isFold }) => ($isFold ? "43px" : "368px")};
    overflow: hidden;
    background: ${theme.color.white};
    padding: 12px 18px;
    box-shadow: none;
    border-radius: 5px;
  }
`;

const Header = styled.h1`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #484848;
  margin-bottom: 20px;

  @media (max-width: ${md}px) {
    min-height: 19px;
    font-size: ${theme.fontSize.FONT_1};
    font-weight: ${theme.fontWeight.SEMI_BOLD};
    margin-bottom: 12px;
  }
`;

const Body = styled.div`
  background: #fefefe;
  border-radius: 10px;
  flex: 1;

  @media (max-width: ${md}px) {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
`;

const EventWrapper = styled.div`
  padding: 18px;
  cursor: pointer;

  @media (max-width: ${md}px) {
    width: 46%;
    padding: 0px;
  }
`;

const EventHeader = styled.h2`
  font-weight: 700;
  font-size: 13px;
  line-height: 15px;
  color: #484848;
  margin-bottom: 13px;

  @media (max-width: ${md}px) {
    margin-bottom: 8px;
    font-size: ${theme.fontSize.FONT_2};
  }
`;

const EventCnt = styled.strong`
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  color: #484848;

  @media (max-width: ${md}px) {
    font-size: ${theme.fontSize.HEADER_1};
  }
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #e0e0e0;

  @media (max-width: ${md}px) {
    display: none;
  }
`;

const MarkerAndCountWrapper = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: ${md}px) {
    gap: 20px;
    height: 34px;
    align-items: center;
  }
`;

export default DetectByEvent;
